// Copyright (c) 2017 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import AccordionState from '../../../../shared/components/smart-accordion/state/accordion';
import Facets from '../../state/facets';
import OpenPipsFacets from './open-pips-facets';
import OpenPipsSummary from '@deere/cps-it.warranty-model-factory/lib/open-pips-summary';
import OpenPipsSummaryList from './open-pips-summary/open-pips-summary-list';

class OpenPipsAside extends Component {

    componentWillMount() {

        this.props.actions.readOpenPipsSummary();

    }

    render() {

        return (
            <aside className='aside-container'>
                <OpenPipsSummaryList openPipsSummary={this.props.openPipsSummary}/>
                <OpenPipsFacets
                    actions={this.props.actions}
                    facets={this.props.facets}
                    reportsAccordion={this.props.reportsAccordion}
                    reportsRoutes={this.props.reportsRoutes}
                />
            </aside>
        );

    }

}

OpenPipsAside.displayName = 'OpenPipsAside';
OpenPipsAside.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets),
    openPipsSummary: PropTypes.instanceOf(OpenPipsSummary).isRequired,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired
};

export default OpenPipsAside;



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-aside/open-pips-aside.js